<template>
  <b-row>
    <b-col md="12">
      <b-modal
        v-model="modal.filter"
        centered
        size="lg"
        title="Filter Data"
        ok-title="Filter"
        @ok="
          () => {
            viewMenu == 'progress'
              ? getMaintenanceList()
              : getMaintenanceFinishedList()
          }
        "
      >
        <template v-if="viewMenu == 'progress'">
          <FilterMaintenanceForm
            v-model="filters"
            :fleetCategoryOpt="fleetCategoryOpt"
            :fleetNameOpt="fleetNameOpt"
            :statusList="statusList"
            :jobClassList="jobClassList"
            :jobTypeList="jobTypeList"
          />
        </template>
        <template v-else>
          <FilterMaintenanceForm
            v-model="filtersFinish"
            :fleetCategoryOpt="fleetCategoryOpt"
            :fleetNameOpt="fleetNameOpt"
            :statusList="statusList"
            :jobClassList="jobClassList"
            :jobTypeList="jobTypeList"
          />
        </template>
      </b-modal>
    </b-col>

    <b-col md="12">
      <iq-card>
        <template v-slot:headerTitle>
          <h4 class="card-title text-primary">
            <strong>Maintenance List</strong>
          </h4>
        </template>
        <template v-slot:body>
          <MaintenanceSummaryCards
            :meta="maintenance.meta"
            @onClickCard="
              (val) => {
                filters.status = val
                getMaintenanceList()
              }
            "
          />
          <CustomNav
            :items="navItems"
            class="mb-3"
            @item-click="(val) => (viewMenu = val)"
          ></CustomNav>

          <template>
            <MaintenanceSummaryListProgress
              :jobClassList="jobClassList"
              :jobTypeList="jobTypeList"
              @toggleFilter="toggleFilter"
              :maintenance="
                viewMenu == 'progress' ? maintenance : maintenanceFinished
              "
              @refetch="
                viewMenu == 'progress'
                  ? getMaintenanceList()
                : getMaintenanceFinishedList()
              "
              :statusList="statusList"
              :fleetCategoryOpt="fleetCategoryOpt"
              :viewMenu="viewMenu"
              :filters="viewMenu == 'progress' ? filters : filtersFinish"
              @resetFilter="resetFilter"
            />
          </template>
          <div class="d-flex justify-content-end align-items-center mt-3">
            <b-pagination
              class="mb-0 mr-3"
              @change="
                (page) => {
                  meta.page = page
                  getMaintenanceList()
                }
              "
              v-model="meta.page"
              :total-rows="meta.total"
              :per-page="meta.perPage"
              first-number
              align="center"
            ></b-pagination>
            <b-form-select
              plain
              v-model="meta.perPage"
              :options="limitOptions"
              style="width: 140px"
              @input="getMaintenanceList"
            ></b-form-select>
          </div>
        </template>
      </iq-card>
    </b-col>
  </b-row>
</template>

<script>
import AdvancedFilter from './Components/AdvancedFilter.vue'
import MaintenanceSummaryListProgress from './MaintenanceSummaryListProgress.vue'
import MaintenanceSummaryListFinish from './MaintenanceSummaryListFinish.vue'
import CustomNav from '@/src/components/global/CustomNav.vue'
import MaintenanceSummaryCards from './Components/MaintenanceSummaryCards.vue'
import FilterMaintenanceForm from './Components/FilterMaintenanceForm.vue'
import {
  filesActions,
  fleetsActions,
  maintenanceActions,
} from '@/src/Utils/helper'
import moment from 'moment'
import { limitOptions } from '@/src/core/mock/data/optionsData'

export default {
  name: 'MaintenanceSummaryList',
  props: {},
  components: {
    AdvancedFilter,
    MaintenanceSummaryListProgress,
    MaintenanceSummaryListFinish,
    CustomNav,
    MaintenanceSummaryCards,
    FilterMaintenanceForm,
  },
  mounted() {},
  data() {
    return {
      limitOptions: limitOptions,
      viewMenu: 'progress',
      tabMenuOptions: {
        progress: {
          isHover: false,
          isActive: false,
        },
        finish: {
          isHover: false,
          isActive: false,
        },
      },
      list: {},
      modal: {
        filter: false,
      },
      loading: {
        fleet: false,
      },
      navItems: [
        { label: 'Maintenance List', value: 'progress' },
        { label: 'Maintenance Finish', value: 'finish' },
      ],
      statusList: [
        { value: null, text: 'All' },
        { value: 'TOWARDS', text: 'Towards Jobs' },
        { value: 'OVERDUE', text: 'Overdue' },
        { value: 'POSTPONE', text: 'Postponed' },
        { value: 'MONTHS3', text: 'Next 3 Month' },
        { value: 'MONTHS6', text: 'Next 6 Month' },
        { value: 'MONTHS12', text: 'Next 12 Month' },
      ],
      filters: {
        action: '',
        search: '',
        status: null,
        dateRange: [
          new Date(moment().startOf('year')),
          new Date(moment().endOf('year')),
        ],
        perPage: 10,
        page: 1,
        totalPage: 1,
        vehicleIds: [],
        jobTypeIds: [],
        jobClassIds: [],
        vehicleTypeIds: [],
        filterJobType: 'jobClass',
      },
      filtersFinish: {
        action: '',
        search: '',
        status: null,
        dateRange: [
          new Date(moment().startOf('year')),
          new Date(moment().endOf('year')),
        ],
        perPage: 10,
        page: 1,
        totalPage: 1,
        vehicleIds: [],
        jobTypeIds: [],
        jobClassIds: [],
        vehicleTypeIds: [],
        filterJobType: 'jobClass',
      },
      meta: {
        page: 1,
        perPage: 10,
        currentPage: 1,
        total: 1,
      },
      fleetCategoryOpt: [],
      fleetNameOpt: [],
      jobClassList: [],
      jobTypeList: [],
      maintenance: {
        selectedJob: 'job_class',
        selectedJobClass: null,
        isLoading: false,
        editMode: false,
        params: {
          perPage: 10,
          page: 1,
          totalPage: 1,
        },
        data: [],
        meta: {
          towards: 0,
          overdue: 0,
          postponed: 0,
          '3months': 0,
          '6months': 0,
          '12months': 0,
        },
      },
      maintenanceFinished: {
        isLoading: false,
        params: {
          status: '',
          perPage: 25,
          page: 1,
        },
        data: [],
      },
    }
  },
  methods: {
    ...fleetsActions,
    ...maintenanceActions,
    ...filesActions,
    resetFilter() {
      if (this.viewMenu == 'progress') {
        this.filters = {
          action: '',
          search: '',
          status: null,
          dateRange: [
            new Date(moment().startOf('year')),
            new Date(moment().endOf('year')),
          ],
          perPage: 10,
          page: 1,
          totalPage: 1,
          vehicleIds: [],
          jobTypeIds: [],
          jobClassIds: [],
          vehicleTypeIds: [],
          filterJobType: 'jobClass',
        }
        this.getMaintenanceList()
      } else {
        this.filtersFinish = {
          action: '',
          search: '',
          status: null,
          dateRange: [
            new Date(moment().startOf('year')),
            new Date(moment().endOf('year')),
          ],
          perPage: 10,
          page: 1,
          totalPage: 1,
          vehicleIds: [],
          jobTypeIds: [],
          jobClassIds: [],
          vehicleTypeIds: [],
          filterJobType: 'jobClass',
        }
        this.getMaintenanceFinishedList()
      }
    },
    mappingIdsToCode(data) {
      let dataTemp = []
      if (!data?.length) return ''
      data.forEach((el) => {
        dataTemp.push(el.code)
      })
      return dataTemp.toString()
    },
    toggleFilter() {
      this.modal.filter = !this.modal.filter
    },
    async fetchFleets() {
      let params = {
        page: 1,
        perPage: 1000,
      }
      try {
        this.fleetNameOpt = []
        const res = await this.getFleets(params)
        res.data.forEach((el) => {
          el.componentSetup = []
          this.fleetNameOpt.push({
            name: el.name,
            code: el.id,
          })
        })
      } catch (error) {
        console.log(error)
      }
    },
    async fetchFleetCategories() {
      let params = {
        page: 1,
        perPage: 1000,
      }
      try {
        this.fleetCategoryOpt = []
        const res = await this.getFleetTypes(params)
        res.data.forEach((el) => {
          el.componentSetup = []
          this.fleetCategoryOpt.push({
            name: el.name,
            code: el.id,
          })
        })
      } catch (error) {
        console.log(error)
      }
    },
    async getJobClassList() {
      const params = {
        page: 1,
        perPage: 1000,
      }

      try {
        this.jobClassList = []
        const res = await this.getJobClass(params)
        res.data.data.forEach((el) => {
          this.jobClassList.push({
            name: `${el.jobClassCode} - ${el.jobClass}`,
            code: el.id,
          })
        })
      } catch (error) {
        console.log(error)
      }
    },
    async getJobTypeList() {
      try {
        const params = {
          page: 1,
          perPage: 1000,
        }
        this.jobTypeList = []
        const res = await this.getJobType(params)
        res.data.data.forEach((el) => {
          this.jobTypeList.push({
            name: `${el.jobTypeCode} - ${el.jobTypeIndex}`,
            code: el.id,
          })
        })
      } catch (error) {
        console.log(error)
      }
    },
    async getMaintenanceList() {
      this.maintenance.isLoading = true
      this.maintenance.data = []

      if (this.maintenance.selectedJob === 'job_class') {
        this.maintenance.params.jobTypeIds = []
      } else {
        this.maintenance.params.jobClassIds = []
      }
      const paramsQ = {
        perPage: this.meta.perPage,
        page: this.meta.page,
        status: this.filters.status,
        search: this.filters.search,
        vehicleIds: this.mappingIdsToCode(this.filters.vehicleIds),
        jobTypeIds: this.mappingIdsToCode(this.filters.jobTypeIds),
        jobClassIds: this.mappingIdsToCode(this.filters.jobClassIds),
      }

      const filterParams = this.$options.filters.cleanObject(paramsQ)

      try {
        const res = await this.getMaintenance(filterParams)
        const sortedData = res.data.data.sort((a, b) => {
          const dateA = new Date(
            a.lastMaintenanceDate.split('-').reverse().join('-')
          )
          const dateB = new Date(
            b.lastMaintenanceDate.split('-').reverse().join('-')
          )

          // If the years are different, prioritize entries from 2022
          if (dateA.getFullYear() !== dateB.getFullYear()) {
            return dateA.getFullYear() - dateB.getFullYear()
          }

          // If the years are the same, proceed with regular sorting
          return dateA - dateB
        })

        this.maintenance.data = sortedData
        this.meta.page = res.data.currentPage
        this.meta.perPage = res.data.perPage
        this.meta.total = res.data.total
        this.meta.totalPage = res.data.totalPage

        this.maintenance.meta.towards = res.data.meta[0]?.towards
        this.maintenance.meta.overdue = res.data.meta[0]?.overdue
        this.maintenance.meta.postponed = res.data.meta[0]?.postponed
        this.maintenance.meta['3months'] = res.data.meta[0]?.['3months']
        this.maintenance.meta['6months'] = res.data.meta[0]?.['6months']

        this.maintenance.isLoading = false
      } catch (error) {
        this.maintenance.data = []
        this.maintenance.isLoading = false
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async getMaintenanceFinishedList() {
      this.maintenanceFinished.isLoading = true

      const paramsQ = {
        perPage: this.meta.perPage,
        page: this.meta.page,
        search: this.filtersFinish.search,
        status: this.filtersFinish.status,
        vehicleIds: this.mappingIdsToCode(this.filtersFinish.vehicleIds),
        jobTypeIds: this.mappingIdsToCode(this.filtersFinish.jobTypeIds),
        jobClassIds: this.mappingIdsToCode(this.filtersFinish.jobClassIds),
        startDate: moment(this.filtersFinish.dateRange[0]).format('DD-MM-YYYY'),
        endDate: moment(this.filtersFinish.dateRange[1]).format('DD-MM-YYYY'),
      }

      const filterParams = this.$options.filters.cleanObject(paramsQ)

      const res = await this.getMaintenanceFinished(filterParams)
      if (res.status == 'success') {
        if (res.data.data && res.data.data.length > 0) {
          this.maintenanceFinished.data = res.data.data
          this.meta.page = res.data.currentPage
          this.meta.perPage = res.data.perPage
          this.meta.total = res.data.total
          this.meta.totalPage = res.data.totalPage
        }
        this.maintenanceFinished.isLoading = false
      } else {
        this.maintenanceFinished.data = []
        this.maintenanceFinished.isLoading = false
        this.$swal(`Oops!`, res.data, 'error')
      }
    },
  },
  watch: {
    viewMenu: {
      handler(newVal, oldVal) {
        ;(this.meta.page = 1), (this.meta.perPage = 10)
        this.meta.total = 1
        if (newVal === 'progress') {
          this.getMaintenanceList()
        } else if (newVal === 'finish') {
          this.getMaintenanceFinishedList()
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.fetchFleets()
    this.fetchFleetCategories()
    this.getJobClassList()
    this.getJobTypeList()
  },
}
</script>

<style scoped>
.custom-button {
  background-color: #2bdcaa; /* Custom color */
  color: white; /* Text color */
  margin-top: 32px;
}
.btn-menu:hover {
  background: #213f8b !important;
  border: #213f8b;
}
.btn-menu-active {
  background: #213f8b !important;
  color: white !important;
}
</style>
